export const EVENT_FREETEXT_SENT = 'notifications.freetext.sent'
